import get from 'lodash/get';

import {
  BUILDING_LIST_REQUESTED,
  DELETE_PMC_SUCCESS,
  GET_PERSON_DETAILS_SUCCESS,
  PMC_LIST_REQUESTED,
  PMC_REQUESTED,
  PMC_STAFF_REQUESTED,
  TOGGLE_LOGO_DISABLED_SUCCESS,
} from '../actionConstants';

import { arrayToObject, mergeObjects } from './utils';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DELETE_PMC_SUCCESS: {
      const newState = { ...state };
      delete newState[action.id];
      return {
        ...newState,
      };
    }
    case PMC_LIST_REQUESTED: {
      const pmcs =
        get(action, 'payload.data.data', null) ||
        get(action, 'payload.data', []);
      const newState = mergeObjects(state, arrayToObject(pmcs));
      return {
        ...newState,
      };
    }
    case PMC_REQUESTED: {
      const PMCId = get(action, 'payload.data.id', null);
      if (!PMCId) return state;
      return {
        ...state,
        [PMCId]: {
          ...state[PMCId],
          ...action.payload.data,
        },
      };
    }
    case PMC_STAFF_REQUESTED: {
      const staff = get(action, 'payload.data', []);
      if (!action.PMCId || staff?.length < 1) return state;
      return {
        ...state,
        [action.PMCId]: {
          ...state[action.PMCId],
          staff,
        },
      };
    }
    case BUILDING_LIST_REQUESTED: {
      const buildings = get(action, 'payload.data') || [];
      if (!action.PMCId || buildings?.length < 1) return state;
      return {
        ...state,
        [action.PMCId]: {
          ...state[action.PMCId],
          buildings: buildings.map((building) => building.id),
        },
      };
    }
    case TOGGLE_LOGO_DISABLED_SUCCESS: {
      const { pmcId, disabledLogo, disabledLightLogo, disabledDarkLogo } =
        action;
      if (!pmcId) return state;
      return {
        ...state,
        [pmcId]: {
          ...state?.[pmcId],
          disabledLogo,
          disabledLightLogo,
          disabledDarkLogo,
        },
      };
    }
    case GET_PERSON_DETAILS_SUCCESS: {
      const { pmcId, personId, res } = action;
      return {
        ...state,
        [pmcId]: {
          ...state[pmcId],
          personDetails: {
            [personId]: res?.data,
          },
        },
      };
    }
    default:
      return state;
  }
};
